import { fn, IInfOperation, INamed } from '@common/utils';

import UISafe = fn.UISafe;
import EncodeQueryData = fn.EncodeQueryData;

import { DialogService, IDialogState } from '@services/dialogservice';
import * as rwf3 from '@common/rwf';
import { IRWF3DocLink } from '@common/preview/preview.shared';

import { NavPageItem } from '../../navdata/navdata';
import rwf3Pages = rwf3.Pages;

import { CtrlRwfSendMail } from '../sendmail/sendmail.ctrl';
import { RwfBootstrap, GetKWF3DocumentUrl, ValidateFileSize } from '@common/rwf';
import { GridColumn, IPageMetaData } from '@common/nav';
import { TMPL_DocDescriptionMainDocBold } from '@rwfangularjs/KWFUtils';
import { GetGridOptions } from '@common/navkendo';
const WFInstance = rwf3Pages.FDRW_WFInstance;
export const SetCurrWFDocument = "$SetCurrWfDocument";
/** Controller for Displaying Supplement Documents Assumption : some parent Scope has Property "KWFSession.KWFService.WFInstance" with the root item (BAD, other way?) */
export class CtrlKWF3SupplementDocuments {
    static Directive = [function (): ng.IDirective {
        return {
            controller: CtrlKWF3SupplementDocuments,
            controllerAs: 'vm',
            scope: {
                allowedit: "=allowedit",
                allowadddocuments: '=allowadddocuments',
               // usersettings: '=usersettings',
                DocOptions: '=docoptions',
                CurrentInstance: '=wfinstance'
            },
            template: require('./supplementdocuments.html')
        };
    }];
    static $inject = ["$scope", "RwfBootstrap", "DialogService"];
    constructor($scope: ng.IScope & {
        allowadddocuments: boolean,
        allowedit: boolean;
        CurrentInstance: NavPageItem,
    },
        RwfBootstrap: RwfBootstrap,
        private DialogService: DialogService) {
        setupAsChildScope($scope);
        let me = this;
        $scope.$on(SetCurrWFDocument, (s, docId: string) => {
            var newItem = me.CurrentInstance.Model.Workflow_Documents_Sub.filter(item => item.ID == docId)[0];
            if (newItem) {
                this.UISelectedItem = newItem;
                setPreviewAction(false);
            }
        });
        /** current WFInstance based NavPageItem instance */
        let /** Delete an Item */
            deleteItemAction = () => {
                // Wait for UISelectedItem update
                fn.debounce(() => {
                    var item = this.UISelectedItem;
                    preventPreviewOnAction = true;
                    const CurrentInstance = me.CurrentInstance;
                    CurrentInstance.Anchor.EnqueueOperation(() =>
                        {
                            if(info.DeleteSelected.Enabled == false) {
                                return DialogService.ShowError('Das Löschen von Dokumenten ist in der aktuellen Ansicht nicht möglich!');
                            }
                            return DialogService.ShowConfirm({ message: 'Dokument "' + (item.Description || '') + '" wirklich löschen?', title: "RWF" }).then(answer => {
                            if (answer) {
                                CurrentInstance.ExecuteMethod(WFInstance.Methods.DeleteFile(CurrentInstance.Key, item.ID)).then(() => {
                                    if (!this.UISelectedItem && item === currPreviewItem) {
                                        this.UISelectedItem = CurrentInstance.GetValue("Workflow_Documents_Sub").filter(item => item.Type === rwf3.Type_10.Main_Document)[0];
                                        setPreviewAction(false);
                                    }
                                }, err => DialogService.ShowError(err));
                            }
                        }).finally(() => {
                            preventPreviewOnAction = false;
                        }); }
                    );
                }, 100)();
            },
            preventPreviewOnAction = false;

        /** Set document of preview dock */
        let currPreviewItem: rwf3.IIAX_WF_Documents_Sub,
            setPreviewAction = (force: boolean) => {
                // Wait for UISelectedItem update + delete event before previewing
                fn.debounce(() => {
                    var item = this.UISelectedItem;
                    if (item.ID && item.WorkflowInstanceID && !preventPreviewOnAction) {
                        var docId = item.ID;
                        var docUrl = GetKWF3DocumentUrl(item.WorkflowInstanceID, docId, me.NavUrl);
                        var doclink: IRWF3DocLink = {
                            ID: docId,
                            WorkflowInstanceID: item.WorkflowInstanceID,
                            NavUrl: me.CurrentInstance.ClientInfo.Url,
                            AllowEdit: item.Type === rwf3.Type_10.Main_Document && !!($scope.allowadddocuments),
                            IsArchived: false,
                            Title: item.Description ? item.Description : '',
                            Url: docUrl,
                            Extension: item.Extension,
                            Type: item.Type
                        };
                        currPreviewItem = item;
                        $scope.$root.$broadcast("$previewChange", { Link: doclink, Doc: item, Force: force });
                    }
                }, 200)();
            };

        /** rename item Action */
        let renameAction = () => {
            preventPreviewOnAction = true;
            // Wait for UISelectedItem update
            fn.debounce(() => {
                const item = this.UISelectedItem;
                const currentInstance = me.CurrentInstance;

                if (item && item.ID && currentInstance) {
                    var previous = item.Description;
                    return UISafe(DialogService.ShowInput({ inputText: previous, title: "Dokument", message: "Neue Beschreibung" }).then(result => {
                        if (result.okPressed && (result.inputString !== "" && result.inputString != previous)) {
                            return currentInstance.ExecuteMethod(WFInstance.Methods.RenameFile(currentInstance.Key, item.ID, result.inputString),
                                () => {
                                    $scope.$root.$broadcast("$previewTitleChange", result.inputString);
                                });
                        }
                    }).finally(() => {
                        preventPreviewOnAction = false;
                    })
                    );
                }
            }, 100)();
        };

        let info = $scope["supDocInfo"] = { // To Avoid Problems with SubScoping, put all Externally necessary props not directly on scope
            fileUpload: <kendo.ui.Upload>null,
            DeleteSelected: {
                Enabled : true,
                Execute: deleteItemAction
            },
            PreviewSelected: {
                Enabled: true,
                Execute: () => setPreviewAction(true)
            },
            RenameSelected: {
                Enabled: true,
                Execute: renameAction
            },
            DownloadDoc: {
                Enabled: true,
                Execute: () => {
                    fn.debounce(() => { // wait for UISelectedItem to be set
                        const doc = this.UISelectedItem,
                            url = GetKWF3DocumentUrl(doc.WorkflowInstanceID, doc.ID, me.NavUrl, doc.Description + "." + doc.Extension, true);
                        window.open(url, "_blank");
                    }, 200)();
                }
            }
        },
            uploadOptions = $scope["uploadOptions"] = <kendo.ui.UploadOptions>{
                async: {
                    saveUrl: GetUploadUrl("", ""), // WOut initial URL : "async mode does not get set!"
                    autoUpload: true,
                },
                enabled: false,
                multiple: true,
                error: (e) => {
                    DialogService.ShowError(e.XMLHttpRequest);
                },
                complete: (c) => {
                    // gets called also on Error
                    var instance = me.CurrentInstance;
                    if (instance)
                        UISafe(instance.Anchor.EnqueueOperation(() => instance.RevertItem(true).then(() => {
                            // Position on uploaded Document
                            this.UISelectedItem = instance.Model.Workflow_Documents_Sub.sort(item => -item.Added.valueOf())[0];
                            setPreviewAction(false);
                            info.fileUpload?.clearAllFiles();
                        })));
                },
                upload: (e) => {
                    try {
                        (e.files || []).forEach(item => ValidateFileSize(item));
                    } catch (err) {
                        DialogService.ShowError(err).then(() => info.fileUpload?.clearAllFiles());
                        fn.error.ThrowCancel(err);
                    }
                },
                localization: {
                    select: "Hochladen..."
                }
            };

        let instanceId: string;

        $scope.$watch(() => $scope.allowedit, allow => info.RenameSelected.Enabled = info.DeleteSelected.Enabled = allow);
        $scope.$watch(() => $scope.CurrentInstance, CurrentInstance => {
            this.CurrentInstance = CurrentInstance;
            var newInstanceId = $scope["WFInstanceId"] = (CurrentInstance && CurrentInstance.GetValue("ID", true)) || undefined;
            if (newInstanceId != instanceId) {
                instanceId = newInstanceId;
                var newSaveUrl = GetUploadUrl(instanceId, (CurrentInstance && CurrentInstance.ClientInfo.Url) || undefined);
                if (uploadOptions.async.saveUrl != newSaveUrl) {
                    uploadOptions.async.saveUrl = newSaveUrl;
                    uploadOptions.enabled = !!newSaveUrl;
                    const fileUpload = info.fileUpload;
                    if (fileUpload && fileUpload instanceof kendo.ui.Upload) {
                        fileUpload.setOptions(uploadOptions);
                        fileUpload.clearAllFiles();
                    }
                }
            }
        });

        /** Update preview on supplement doc selection */
        $scope.$watch<rwf3.IIAX_WF_Documents_Sub>("UISelectedItem", (newValue, oldValue) => {
            this.DeleteDoc.Enabled = newValue && (newValue.Type == rwf3.Type_10.SupDoc || newValue.Type == rwf3.Type_10.PaymOrd);

            if (newValue) {
                setPreviewAction(false);
            }
        });

        $scope.$on("$destroy", () => {
            delete this.CurrentInstance;
            info = $scope["supDocInfo"] = undefined;

        });

        this.RenameDoc = {
            Enabled: true,
            Execute: renameAction
        };

        this.DeleteDoc = {
            Enabled: true,
            Execute: deleteItemAction
        };

        this.DownloadDoc = info.DownloadDoc;
        this.MailDoc = {
            Enabled: true,
            Hidden: "Enabled",
            Execute: () => {
                var wState: IDialogState;
                return this.DialogService.ShowWindow({
                    windowOptions: {
                        title: "Mail Versand von '" + this.UISelectedItem.Description + "'",
                        modal: true,
                        resizable: false
                    },
                    controller: CtrlRwfSendMail,
                    resolve: {
                        "WFDocument": [() => this.UISelectedItem],
                        "Window": [() => () => wState.window],
                        "From": ["RwfBootstrap", (rwf: RwfBootstrap) => rwf.Resolve.then(l => l.RwfUser.E_Mail || fn.error("Für Ihren Benutzer ist keine E-Mail Adresse hinterlegt!"))]
                    },
                    controllerAs: "vm",
                    template: CtrlRwfSendMail.Template
                }).then(w => {
                    return (wState = w).close;
                });
            }
        };
        RwfBootstrap.Resolve.then((p) => this.MailDoc.Enabled = !p.RwfSettings.CheckPages || p.RwfSettings.CheckPages.SmtpMail);
    }

    public CurrentInstance: NavPageItem<rwf3.IFDRW_WFInstance>;

    public UISelectedItem: rwf3.IIAX_WF_Documents_Sub;

    public get NavUrl() { return this.CurrentInstance && this.CurrentInstance.ClientInfo.NavUrl; }

    public readonly MailDoc: IInfOperation;

    public readonly DeleteDoc: IInfOperation;

    public readonly RenameDoc: IInfOperation;

    public readonly DownloadDoc: IInfOperation;
}

/** Instantiate Grid Options w dep. to above controller */
export function GetDocGridOptions(docData: any[], docProperties: IPageMetaData, hideEditCols: boolean) {
    var docFixedColumns: GridColumn[] = [
        { width: 35, template: "<span class='idms_Icon idms_Icon_Search idms_HoverIcon' inf-operation='supDocInfo.PreviewSelected' title='Dokument in Vorschaufenster anzeigen'></span>" },
        { width: 35, hidden: hideEditCols, template: "<span class='idms_Icon idms_Icon_Edit idms_HoverIcon' inf-operation='supDocInfo.RenameSelected' title='Dokument umbenennen'></span>" },
        { width: 35, template: "<span class='idms_Icon idms_Icon_Download idms_HoverIcon' inf-operation='supDocInfo.DownloadDoc' title='Dokument herunterladen'></span>" },
        { width: 35, hidden: hideEditCols, template: "<span class='idms_Icon idms_Icon_Delete idms_MainMenuSubGroupButtonDelete' ng-show='#= Type == 2 || Type == 3 #' inf-operation='supDocInfo.DeleteSelected' title='Dokument löschen'></span>" }
    ],
        docTemplateColumns = <INamed<GridColumn>>{
            "Description": { width: 'auto', template: TMPL_DocDescriptionMainDocBold },
            "Added": { width: 130 },
            "AddedBy": { width: 180 }
        },
        docOptions = GetGridOptions(docData, docProperties, docTemplateColumns);
    docOptions.columns.splice(0, 0, ...docFixedColumns);

    docOptions.filterable = {}; //{ mode: "row" };
    return docOptions;
}

/** TODO : With Custom Sub Controllers and kendo controls there seem to be problems with garbageCollection
   if we do not explicitly cleanup in the case where a scope is not explicitly destroyed
    *but only a parent scope is */
function setupAsChildScope($scope: ng.IScope) {
    if (!$scope || $scope["$NavSetupAsChildScope"])
        return;
    var remove = $scope["$NavSetupAsChildScope"] = $scope.$on("$destroy", () => {
        remove();
        delete $scope["$NavSetupAsChildScope"];
        var watchers = <any[]>$scope["$$watchers"];
        if (watchers && watchers.length != undefined)
            watchers.length = 0;
    });
}

/** Url to Upload a Supplement Document for a Instance */
function GetUploadUrl(wfInstanceKey: string, navUrl: string) {
    return "./infoma.Web.KWF3/UploadDocument?" + EncodeQueryData({ wfInstanceKey: wfInstanceKey, navUrl: navUrl });
}
